import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Card from '../components/Card'
import Section from '../components/Section'
import Wave from '../components/Wave'
import staticdata from '../../staticdata.json'
import Cell from '../components/Cell'
import styled from 'styled-components'

const SectionCaption = styled.p`
  font-weight: 600;
  font-size: 18px !important;
  text-transform: uppercase;
  color: #94a4ba !important;
  text-align: center;
`

const SectionCellGroup = styled.div`
  max-width: 900px;
  margin: 0 auto 100px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 20px;
  padding: 0 20px;

  @media (max-width: 800px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

const IndexPage = () => (
  <Layout>
    <div className="Hero">
      <div className="HeroGroup">
        <h1>Learn to Code </h1>
        <p>
          Learn to Code & Design
          <br /> A self-taught programmer who loves to mix code with art.
        </p>
        <Link to="/page-2/">watch the video</Link>
        <div className="Logos">
          <img
            src={require('../images/logo-figma.png')}
            width="40px"
            alt="figma"
          />
          <img
            src={require('../images/logo-react.png')}
            width="50px"
            alt="react"
          />
          <img
            src={require('../images/gatsby-icon.png')}
            width="50px"
            alt="gatsby"
          />
        </div>
        <Wave />
      </div>
      <div className="Cards">
        <h2>Multiple Cards Section?</h2>
        <div className="CardGroup">
          <Card
            title="Design System"
            text="10 sections"
            image={require('../images/wallpaper.jpg')}
          />
          <Card
            title="React for Designers"
            text="12 sections"
            image={require('../images/wallpaper2.jpg')}
          />
          <Card
            title="Sound Design"
            text="5 sections"
            image={require('../images/wallpaper3.jpg')}
          />
          <Card
            title="ARKit 2"
            text="10 sections"
            image={require('../images/wallpaper4.jpg')}
          />
        </div>
      </div>
      <Section
        image={require('../images/wallpaper2.jpg')}
        logo={require('../images/logo-react.png')}
        title="React for Designers"
        text="Learn how to build a modern site using React and most efficient
        libraries to get your sites/product online. Get familiar with components,
        Grid CSS, animations, interactions, dynamic data with Contentful and
        deploying your site with Netlify."
      />
      <SectionCaption>Section Details?</SectionCaption>
      <SectionCellGroup>
        {staticdata.cells.map(cell => (
          <Cell title={cell.title} image={cell.image} />
        ))}
      </SectionCellGroup>
    </div>
  </Layout>
)

export default IndexPage
